module.exports = __webpack_public_path__ + "img/t1.35fb818e.jpg";